/**
 *
 * Temporary file to store the routes that have been migrated to App Router
 * All other routes use Pages Router
 * This is used to determine which router to use
 * Update this when more routes are migrated to App Router
 */
export const APP_ROUTER_ROUTES = [
    '/signin',
    '/home',
    '/no-active-sp',
    '/logout',
    '/notifications',
    '/dashboard/overview',
    '/dashboard/view/',
    '/dashboard/customization/',
    '/dashboard/report/',
    '/giveaway-picker',
    '/giveaway-picker/results',
    '/reports/',
    'reports/create/account/',
    'reports/create/dashboard/',
    'reports/create/hashtag/',
    'reports/create/competitor/',
    'reports/edit/'
];

/**
 * Remove locale prefix from a path (e.g. /en/signin → /signin)
 */
export function stripLocalePrefix(path: string): string {
    return path.replace(/^\/(en|fr|es)(?=\/|$)/, '') || '/';
}
